import { render, staticRenderFns } from "./OrganizationProfileHeader.vue?vue&type=template&id=716d371c"
import script from "./OrganizationProfileHeader.vue?vue&type=script&lang=js"
export * from "./OrganizationProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports